// ==========================================================================
// Smooth Scroll
// ==========================================================================
/* jshint esnext: true */
import { $document } from '../utils/environment';
import AbstractModule from './AbstractModule';
import LocomotiveScroll from './LocomotiveScrollManager';

export default class extends AbstractModule {
    constructor (options) {
        super(options);
    }

    init() {
        this.scroll = new LocomotiveScroll({
            container: this.$el,
            selector: '.js-animate',
            smooth: true,
            mobile: false,
            mobileContainer: $document,
        });
    }

    // Destroy
    // ==========================================================================
    destroy() {
        this.scroll.destroy();
    }
}
